import type { ReactElement } from 'react';
import DialogConfirm from 'common/ui/DialogConfirm';
import Input from 'common/ui/Input';
import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { Colors } from 'styles';

type WorkstationIDSubmissionDialogProps = {
  open: boolean;
  value: string;
  error: string | null;
  onChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export const WorkstationIDSubmissionDialog = ({
  open,
  value,
  error,
  onChange,
  onConfirm,
  onCancel,
}: WorkstationIDSubmissionDialogProps): ReactElement => {
  return (
    <DialogConfirm
      slug="reporter-workstation-id-submission"
      open={open}
      onClose={onCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText="Continue"
      dialogWidth="390px"
      contentWidth="325px"
    >
      <Stack vertical space="small">
        <Text
          color={Colors.white}
          css={`
            font-size: 22px;
            text-align: left;
            font-weight: 500;
          `}
        >
          Workstation ID required
        </Text>
        <Text
          color={Colors.gray9}
          css={`
            text-align: left;
            line-height: 1.1;
          `}
        >
          A Workstation ID is required to continue. It will be saved for future reports on this
          device, and can be updated in Settings &gt; Reporter Settings.
        </Text>
        <Input
          autoFocus
          fullWidth
          variant="dark"
          borderColor={error != null ? Colors.red5 : undefined}
          placeholder="Enter Workstation ID"
          value={value}
          data-testid="submission-workstation-id-input"
          css={`
            input {
              text-align: left;
            }

            input::placeholder {
              color: ${Colors.gray7};
              text-align: left;
            }
          `}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onConfirm();
            }
          }}
        />
        <div
          css={`
            min-height: 1.25rem;
            display: flex;
            align-items: flex-start;
            margin-top: -6px;
          `}
        >
          {error != null ? (
            <Text color="error" variant="caption" data-testid="submission-workstation-id-error">
              {error}
            </Text>
          ) : (
            <Text
              aria-hidden
              variant="caption"
              css={`
                visibility: hidden;
              `}
            >
              placeholder
            </Text>
          )}
        </div>
      </Stack>
    </DialogConfirm>
  );
};
